import { ActivityFieldsFragment } from '~/graphql/types';

const isDeleted = (activity: ActivityFieldsFragment): boolean =>
  'deleted' in activity && activity.deleted;

export default isDeleted;
